import type { components } from './api';

type RepoCatalogo = components['schemas']['RepoCatalogo'];
type Collegato = components['schemas']['Collegato'];

/**
 * Il ramo con cui un'istanza parte nel catalogo.
 *
 * Se il repository è già collegato, il suo: da qui non si cambia. Altrimenti
 * la major dell'istanza, che è la convenzione di Odoo e di OCA — una 17.0
 * prende il 17.0 — se il repository ce l'ha. Se non ce l'ha, nessuno: meglio
 * un'istanza che non si seleziona finché non si sceglie, che una 17.0 col
 * codice del 18.0.
 */
export function ramoIniziale(
  istanza: { id: string; odooMajor: string },
  collegati: Collegato[] | null,
  rami: string[],
): { ramo: string; bloccato: boolean } {
  const gia = (collegati ?? []).find((c) => c.instanceId === istanza.id);
  if (gia) return { ramo: gia.branch, bloccato: true };
  return { ramo: rami.includes(istanza.odooMajor) ? istanza.odooMajor : '', bloccato: false };
}

/**
 * I moduli dei rami scelti, uniti e in ordine, ognuno con i rami in cui manca:
 * fra una major e l'altra OCA non porta tutti i moduli insieme, e chi sceglie
 * deve sapere che su quell'istanza quel modulo non arriverà.
 */
export function unioneModuli(perRamo: Record<string, string[]>): Array<{ nome: string; mancaIn: string[] }> {
  const rami = Object.keys(perRamo).sort();
  const nomi = [...new Set(rami.flatMap((r) => perRamo[r] ?? []))].sort();
  return nomi.map((nome) => ({ nome, mancaIn: rami.filter((r) => !(perRamo[r] ?? []).includes(nome)) }));
}

/** I repository che corrispondono alla ricerca, nella fonte scelta ('' è tutte). */
export function trovaRepo(repos: RepoCatalogo[], testo: string, fonte: string): RepoCatalogo[] {
  const t = testo.trim().toLowerCase();
  return repos.filter(
    (r) =>
      (!fonte || r.owner.toLowerCase() === fonte.toLowerCase()) &&
      (!t || `${r.owner}/${r.name} ${r.description ?? ''}`.toLowerCase().includes(t)),
  );
}

/**
 * Il repository del catalogo a quell'indirizzo, se c'è: come lo si scrive in
 * un blueprint, in https o in ssh, con o senza `.git`.
 */
export function repoDelCatalogo(repos: RepoCatalogo[], url: string): RepoCatalogo | undefined {
  const m = url.trim().match(/(?:^|[/@])github\.com[/:]([\w.-]+)\/([\w.-]+?)(?:\.git)?\/?$/i);
  if (!m) return undefined;
  const [owner, name] = [m[1]!.toLowerCase(), m[2]!.toLowerCase()];
  return repos.find((r) => r.owner.toLowerCase() === owner && r.name.toLowerCase() === name);
}

/**
 * I rami da cui un blueprint prende i moduli da scegliere: quello fissato, o,
 * senza — che vuol dire la major dell'istanza —, le major che Molo gestisce e
 * il repository ha. Così si vede subito su quale versione un modulo manca.
 */
export function ramiDaLeggere(ramo: string, rami: string[], major: string[]): string[] {
  return ramo ? [ramo] : rami.filter((r) => major.includes(r)).sort();
}
